import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

/**
 * /r/:token — the receipt link from the payment SMS. The link stays on the site's domain;
 * the PDF itself is loaded from the API (GET /r/:token) and shown / downloaded from memory.
 */
@Component({
  selector: 'app-receipt-view',
  templateUrl: './receipt-view.component.html',
  styleUrls: ['./receipt-view.component.css'],
  host: {
    class: 'fill-screen'
  }
})
export class ReceiptViewComponent implements OnInit, OnDestroy {
  state: 'loading' | 'ready' | 'not-found' | 'error' = 'loading';
  previewUrl: SafeResourceUrl | null = null;
  downloadUrl: SafeUrl | null = null;
  private objectUrl: string | null = null;
  private loadSub: Subscription;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
    const token = this.route.snapshot.paramMap.get('token') || '';
    this.loadSub = this.http
      .get(`${environment.apiUrl}/r/${encodeURIComponent(token)}`, { responseType: 'blob' })
      .subscribe({
        next: (pdf) => {
          if (!pdf) {
            this.state = 'error';
            return;
          }
          this.objectUrl = URL.createObjectURL(new Blob([pdf], { type: 'application/pdf' }));
          this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.objectUrl);
          this.downloadUrl = this.sanitizer.bypassSecurityTrustUrl(this.objectUrl);
          this.state = 'ready';
        },
        error: (err) => {
          this.state = err?.status === 404 ? 'not-found' : 'error';
        },
      });
  }

  ngOnDestroy(): void {
    this.loadSub?.unsubscribe();
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
    }
  }
}
